/************************************************************************************
  Customize the application by changing the values in this file
*************************************************************************************/

export const config = {
  styledText: "Talent Design Studio GPT",
  applicationName: "Talent Design Studio GPT",
  companyName: "UCI",
  applicationSummary: 
    "UCI Paul Merage School of Business's exclusive AI tool, designed to provide answers to a diverse " +
    "range of inquiries about the school and the programs we offer. Feel free to begin by " +
    "asking a question or choosing from the sample questions provided below.",
}

export const exampleQuestions = [
  "What is UCI Paul Merage School of Business?",
  "What courses should I take in order to apply for a finance marketing role?"
]
